module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/line-7@1x.png?1.0.17";